import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';

import { useApplicationContext } from '../../utils/applicationContext';
import { SEARCH_STRING_MANIFEST_INFO_SETTING_KEY } from 'shared/constants/microfrontends';
import { IManifestInfo } from 'shared/types/manifestInfo';

const SEARCH_UPDATED_EVENT = 'search:updated';

enum ESearchType {
  List = 'list',
  Map = 'map',
}

type TSearchUpdatedEventDetail = {
  url: string;
  type: ESearchType;
};

export const SearchStringContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const manifestInfo = config.get<IManifestInfo | null>(SEARCH_STRING_MANIFEST_INFO_SETTING_KEY);

  React.useEffect(() => {
    const onSearchUpdated = ({ detail: { url } }: CustomEvent<TSearchUpdatedEventDetail>) => {
      window.location.href = url;
    };

    addEventListener(SEARCH_UPDATED_EVENT, onSearchUpdated);

    return () => {
      removeEventListener(SEARCH_UPDATED_EVENT, onSearchUpdated);
    };
  }, []);

  if (!manifestInfo) {
    return null;
  }

  return <Microfrontend {...manifestInfo} />;
};
